var core = require('org_km/product/base');
var toastHelpers = require('core/components/toast');

/**
 * Append the gallery images to the other image types except gallery & swatch
 * @param images
 */
function appendGalleryImages(images) {
    if (images.gallery && images.gallery.length > 0) {
        Object.keys(images).forEach(function (key) {
            if (key !== 'gallery' && key !== 'swatch') {
                Array.prototype.push.call(images[key], ...images.gallery);
            }
        })
    }
}

// override to maintain markup structure required for wishlist button and zoom customizations
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVariant;
    var b = window.UncachedData.isTransactionalContext;
    var isSetItem = $productContainer.hasClass('product-set-item-detail') ? true : false;
    appendGalleryImages(response.product.images);

    if (response.product.variationAttributes) {
        this.updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVariant = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVariant) {
            $productContainer.parent('.bonus-product-item').data('pid', response.product.id);
            $productContainer.parent('.bonus-product-item').data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update primary images
    var primaryImages = response.product.images;
    var pdpGalleryAssets = response.product.pdpGalleryAssets;
    var $oldWishlistIcon = $productContainer.find('div.slide .product-list-enhancements-toggle-product').first().clone(true);

    this.createSlider(primaryImages, pdpGalleryAssets, $productContainer.find('.primary-images'));
    // if variant is a product set item, update the sample image
    if (isSetItem) {
        $productContainer
            .find('.product-set-item-main-image')
            .attr('src', primaryImages.large[0].url)
            .attr('alt', primaryImages.large[0].alt);
    }

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    this.updateAvailabilityProcess(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        if(window.UncachedData.isTransactionalContext) {
            $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
                product: response.product, $productContainer: $productContainer
            }).trigger('product:statusUpdate', response.product);
        }
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty().html(this.getAttributesHtml(response.product.attributes));

    // Update wishlist (org_km overrides here)
    if ($oldWishlistIcon && $oldWishlistIcon.length) {
        var oldProductName = $oldWishlistIcon.attr('data-productname');
        var newProductName = response.product.productName;
        var $newWishlistIcon = $oldWishlistIcon;

        $newWishlistIcon.attr('data-wishlistpid', response.product.wishlistpid);
        $newWishlistIcon.attr('data-addmessage', $newWishlistIcon.attr('data-addmessage').replace(oldProductName, newProductName));
        $newWishlistIcon.attr('data-removemessage', $newWishlistIcon.attr('data-removemessage').replace(oldProductName, newProductName));
        $newWishlistIcon.attr('data-productname', newProductName);

        //Make heart icon accurate
        var wishlist = require('core/productListEnhancements/helpers.js');
        wishlist.updateLinkData($newWishlistIcon);

        var $newSliderMainImages = $productContainer.find('div.primary-images-main div.slide img');
        $newSliderMainImages.each((_i, newImage) => {
            var $newImage = $(newImage);
            $newImage.closest('.zoom-image-container').after($newWishlistIcon.clone(true));
        });
    }

    $('.highlighted-swatch-carousel-badge', $productContainer).remove();

    if (response.product.highlightedSwatches && response.product.highlightedSwatches.length) {
        var $selectedSwatch = $('.swatch-value.selected', $productContainer);
        var attrValue = $selectedSwatch.attr('data-attr-value');
        if (response.product.highlightedSwatches.includes(attrValue)) {
            var $img = $selectedSwatch.find('.highlighted-swatch-img');

            $('.primary-images .primary-images-main', $productContainer).append(`
                <div class="badge-product-container badge-image-over justify-content-center highlighted-swatch-carousel-badge">
                <span class="badge-product background--">
                    <img class="badge-icon" src="${$img.attr('src')}">
                </span>
                </div>
                `);
        }
    }
}


/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else  if (($el).hasClass('single-variant-quick-add-to-cart')) {
        pid = $($el).data('pid');
    } else  if (($el).parents('.popover').length) {
        pid = $($el).closest('.product-detail.product-quick-add-to-cart').data('pid');
    } else if (($el).hasClass('order-history-add-to-cart')) {
        pid = $($el).data('pid');
    } else if ($('.size-swatch-container.product-detail').length) {
        pid = $($el).data('pid');
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

function updateTransactionalElements() {
        $('body').on('product:afterAttributeSelect', function (_event, params) {
    var isSalonRewardsCustomer = params.data.isSalonRewardsCustomer || false;
    var isPurchasable = !!params.data.product.kmPurchasable;
    var canBuy = isPurchasable;

    if (isSalonRewardsCustomer) {
        var isTransactionalGroup = params.data.isTransactionalGroup || false;
        var isRewardTierPurchasable = params.data.product.isRewardTierPurchasable || false;
        canBuy = canBuy && isRewardTierPurchasable && isTransactionalGroup;
    }

    var isQuickview = params.container.hasClass('product-quickview');
    var $modal = params.container.closest('.modal-content');

    var $container = isQuickview && $modal.length ? $modal : params.container;
    if (!canBuy || !(
        params.data.isTransactionalContext
    )) {
        $container.find('[data-transactional-element]').addClass('d-none');
        $container.find('[data-non-transactional-element]').removeClass('d-none');
    } else {
        $container.find('[data-transactional-element]').removeClass('d-none');
        $container.find('[data-non-transactional-element]').addClass('d-none');
    }
});
}



/**********
 * shared across QV and PDP and Order History Details
 */
function addToCart() {
    var scope = this;

    // if qty stepper input has focus, we need to blur it so product data can update before button click
    $(document).on('mouseenter', 'button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global', function (event) {
        var $button = $(event.target);
        var $container = $button.closest('.product-detail');
        if (!$container.length) {
            $container = $button.closest('.quick-view-dialog');
        }
        var $qtyStepperInput = $container.find('.quantity-stepper input');

        if ($qtyStepperInput.length && $qtyStepperInput.is(':focus')) {
            $qtyStepperInput.blur();
        }
    });

    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global, .add-to-cart-new', function () {
        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;
        var quantity;

        $('body').trigger('product:beforeAddToCart', this);

        if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
            setPids = [];

            var $products = $(this).closest('.product-detail').find('.product-set-item-detail');
            if (!$products.length) {
                if ($(this).closest('.quick-view-dialog').length) {
                    $products = $(this).closest('.quick-view-dialog').find('.product-set-item-detail');
                } else {
                    $products = $('.product-detail');  // pagedesigner component 'Add all to cart btn' won't have .product-set-item-detail classes
                }
            }

            $products.each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).find('.product-id').text(),
                        qty: $(this).find('.quantity-select').val(),
                        options: scope.methods.getOptions($(this))
                    });
                }
            });
            pidsObj = JSON.stringify(setPids);
        }

        pid = scope.methods.getPidValue($(this));

        var qtySelected = scope.methods.getQuantitySelected($(this));
        if (qtySelected === undefined) {
            qtySelected = $('#qty-cart-container').find('.quantity-stepper.form-control').find('input').val();
        }

        quantity = $(this).hasClass('single-variant-quick-add-to-cart') ? 1 : qtySelected;

        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            if ($(this).hasClass('single-variant-quick-add-to-cart')) {
                addToCartUrl = $(this).data('url');
            } else if ($(this).hasClass('order-history-add-to-cart')) {
                addToCartUrl = $(this).data('cart-url');
            } else {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
                var $productModalbody = $(this).closest('.modal-content');
                addToCartUrl = scope.methods.getAddToCartUrl($productModalbody);
            }
        } else {
            addToCartUrl = scope.methods.getAddToCartUrl($productContainer);
        }

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: scope.methods.getChildProducts(),
            quantity: quantity,
            options: scope.methods.getOptions($productContainer)
        };

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    scope.methods.handlePostCartAdd(data);
                    $('body').trigger('product:afterAddToCart', data);
                    $('body').trigger('product:afterAddToCartQuickview', data); //cart page quickview only
                    $.spinner().stop();
                    scope.methods.miniCartReportingUrl(data.reportingURL);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
}

/**********
 * shared across QV and PDP and Order History Details
 */
function addToCartTaxCart() {
    var scope = this;

    // if qty stepper input has focus, we need to blur it so product data can update before button click
    $(document).on('mouseenter', '.js-add-to-cart-tax', function (event) {
        var $button = $(event.target);
        var $container = $button.closest('.product-detail');
        if (!$container.length) {
            $container = $button.closest('.quick-view-dialog');
        }
        var $qtyStepperInput = $container.find('.quantity-stepper input');

        if ($qtyStepperInput.length && $qtyStepperInput.is(':focus')) {
            $qtyStepperInput.blur();
        }
    });

    $(document).on('click', '.js-add-to-cart-tax', function () {
        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;
        var quantity;
        var isTaxExempt;

        $('body').trigger('product:beforeAddToCart', this);

        pid = $(this).data('pid');
        quantity = $(this).data('stepquantity');
        isTaxExempt = $(this).data('istaxexempt');

        var $productContainer = $(this).closest('.product-detail');
        addToCartUrl = $(this).data('url');

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: scope.methods.getChildProducts(),
            quantity: quantity,
            isTaxExempt: isTaxExempt,
            options: scope.methods.getOptions($productContainer)
        };

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    scope.methods.handlePostCartAdd(data);
                    $('body').trigger('product:afterAddToCart', data);
                    $('body').trigger('product:afterAddToCartQuickview', data); //cart page quickview only
                    $.spinner().stop();
                    scope.methods.miniCartReportingUrl(data.reportingURL);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

core.availability = function availability() {
    $(document).on('change', '.quantity-stepper input', function (e) {
        // TODO: Jovan - Verify if this logic is still required. If not needed, consider refactoring or removing
        // e.preventDefault();
        //
        // var $productContainer = $(this).closest('.product-detail');
        // if (!$productContainer.length) {
        //     $productContainer = $(this).closest('.modal-content').find('.product-quickview');
        // }
        // let pid = $productContainer.data('pid');
        // let uuid = $productContainer.data('uuid');
        // let quantity = $(e.currentTarget).closest('.quantity-stepper').find('input').val();
        //
        // if ($('.bundle-items', $productContainer).length === 0) {
        //     let url = appendToUrl($(e.currentTarget).data('action'), {
        //         pid: pid,
        //         uuid: uuid,
        //         quantity: quantity
        //     });
        //
        //     core.methods.attributeSelect(url,
        //         $productContainer);
        // }
    });
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.product-detail').find('.quantity-stepper input');
    } else if ($el && $('.product-bundle').length) {
        var quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-stepper input');
        var quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-stepper input');
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else if (($el).hasClass('order-history-add-to-cart')) {
        quantitySelected = $($el).parent().find('.quantity-stepper input, .quantity-select')
    } else if ($el.closest('.modal-footer').length) {
        quantitySelected = $el.closest('.modal-footer').find('.quantity-stepper input');
    } else {
        quantitySelected = $('.quantity-stepper input'); // Still need to keep this line too as it's used for PDPs.

        // For PLPs, there can now be multiple quantity selectors on the page.
        if (quantitySelected.length > 1) {
            // Check to see if the passed element has add-to-cart-global class. If so, that means the Add to Cart button
            // was clicked and we look at the closest matching container to find the element that has the .quantity-select class.
            if (($el).hasClass('add-to-cart-global')) {
                quantitySelected = $el.closest('.quantity-add-cart-container').find('.quantity-stepper input');
            } else {
                // getQuantitySelector() is also used when the quantity stepper is used, so this ELSE
                // takes into account of that as the element passed is the quantity selector container.
                quantitySelected = $el.find('.quantity-stepper input');
            }
        }
    }
    return quantitySelected;
}

core.quickAddToCartLoaded = function() {
    $(document).on('quickAddToCart:ready', 'body', (event, modal) => {
        core.enableQuantitySteppers($(modal));
    });
}

function addAllToCartOrderHistory() {
    var scope = this;
    $(document).on('click', 'button.add-all-order-history', function () {
        var orderNumber = $(this).data('order-number');
        var url = $(this).data('add-url');

        var formData = {
            orderNumber: orderNumber.toString()
        }

        $.ajax({
            url: url,
            method: 'POST',
            data: formData,
            success: function (data) {
                scope.methods.handlePostCartAdd(data);
                $('body').trigger('product:afterAddToCart', data);
                $('body').trigger('product:afterAddToCartQuickview', data); //cart page quickview only
                $.spinner().stop();
                scope.methods.miniCartReportingUrl(data.reportingURL);
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
}

function initAddToCartListViewToggle() {
    $('.search-results').on('click', '.viewToggle a', function(e) {
        e.preventDefault();

        var $this = $(this);
        var url = new URL(window.location.href);
        var params = new URLSearchParams(url.search);

        params.delete('viewToggle');

        if ($this.hasClass('viewToggleList')) {
            params.append('viewToggle', 'list');
        } else {
            params.append('viewToggle', 'grid');
        }

        window.location = (url.origin + url.pathname + '?' + params.toString());
    });
}

function initAddToCartListView() {
    var scope = this;

    $('.add-to-cart-list-view').on('click', function(e) {
        e.preventDefault();

        var addToCartUrl = $(this).data().addToCartUrl;
        var data = {
            pidsObj: []
        };

        $('input[name="qty-stepper"]').each(function(index) {
            var pid = $(this).data().pid;
            var qty = parseInt($(this).val(), 10);
            if (pid && qty > 0) {
                data.pidsObj.push({
                    pid: pid,
                    qty: qty
                });
            }
        });

        if (data.pidsObj.length) {
            data.pidsObj = JSON.stringify(data.pidsObj)

            $.spinner().start();

            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: data,
                success: function (data) {
                    scope.methods.handlePostCartAdd(data);
                    $('body').trigger('product:afterAddToCart', data);
                    $('input[name="qty-stepper"]').val('0');
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
}

function handleShowMoreSuccess() {
    var scope = this;
    var $body = $('body');

    var init = function() {
        var $addToCartListView = $('.add-to-cart-list-view');
        if ($addToCartListView.length > 1) {
            $addToCartListView.first().remove();
        }
        scope.initAddToCartListView();
        $body
            .trigger('quantitySteppers:Enable');
    };

    $body
        .on('search:filter--success', init)
        .on('search:sort--success', init)
        .on('search:showMore--success', init);
}

/**
 * Handles input focus for quantity steppers.
 * Selects the input text when focused, unless prevented by a mousedown event.
 */
function handleInputFocus() {
    const $inputs = $('.quantity-stepper input');

    $inputs.each(function() {
        let preventFocus = false;

        $(this).on('mousedown', function() {
            // Prevent focus event from the next mousedown
            preventFocus = true;
        });

        $(this).on('focus', function() {
            // If not prevented, select text
            if (!preventFocus) {
                $(this).select();
            }
        });

        $(this).on('mouseup', function() {
            // Enable focus event after mouse up
            preventFocus = false;
        });
    });
}



core.updateTransactionalElements = updateTransactionalElements;
core.methods.getPidValue = getPidValue;
core.methods.handleVariantResponse = handleVariantResponse;
core.methods.getQuantitySelector = getQuantitySelector;
core.addToCart = addToCart;
core.addToCartTaxCart = addToCartTaxCart;
core.addAllToCartOrderHistory = addAllToCartOrderHistory;
core.initAddToCartListView = initAddToCartListView;
core.initAddToCartListViewToggle = initAddToCartListViewToggle;
core.handleShowMoreSuccess = handleShowMoreSuccess;
core.handleInputFocus = handleInputFocus;



module.exports = core;
